import { actions } from '../../actions/profile/BTexpertise'

export default function BTexpertise( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case actions.SET_BT_EXPERTISE: return setBTExpertise (newState, action );
        case actions.CREATE_BT_EXPERTISE: return createBTExpertise( newState, action.normalisedData );
        case actions.GET_BT_EXPERTISE: return getBTExpertise( newState, action );
        default: return newState;
    }
}

function getBTExpertise ( newState, action ) {

    Object.assign(newState, action);

    return newState;
}

function setBTExpertise ( newState, action ) {

    Object.assign(newState, action);

    return newState;
}

function createBTExpertise ( newState, normalisedData ) {
    return Object.assign( newState, normalisedData );
}



// WEBPACK FOOTER //
// src/client/reducers/profile/BTexpertise.js